var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "white-bg" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c("div", { staticClass: "search-bar" }, [
        _c("input", {
          directives: [
            { name: "focus", rawName: "v-focus" },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchText,
              expression: "searchText",
            },
          ],
          attrs: {
            type: "text",
            placeholder: "Search by name, company, or email",
          },
          domProps: { value: _vm.searchText },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchText = $event.target.value
            },
          },
        }),
      ]),
      _c("div", { staticClass: "sort-bar" }, [
        _c(
          "div",
          { staticClass: "sort-filter-container" },
          [
            _c(
              "md-field",
              [
                _c("vue-select", {
                  attrs: {
                    reduce: function (x) {
                      return x.value
                    },
                    label: "text",
                    options: _vm.sortByOptions,
                    placeholder: "Sort by",
                    clearable: false,
                  },
                  model: {
                    value: _vm.sortBy,
                    callback: function ($$v) {
                      _vm.sortBy = $$v
                    },
                    expression: "sortBy",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.isSales
          ? _c(
              "div",
              { staticClass: "floating-button" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-primary md-just-icon md-round",
                    attrs: { title: "Add Customer" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.createCustomer($event)
                      },
                    },
                  },
                  [_c("md-icon", [_vm._v("add")])],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "md-layout" }, [
      _c("div", { staticClass: "md-layout-item list-container" }, [
        !_vm.loading
          ? _c("div", [
              _vm.searchCustomerList.length
                ? _c(
                    "div",
                    _vm._l(_vm.searchCustomerList, function (customer) {
                      return _c(
                        "div",
                        { key: customer.customerId, staticClass: "list-item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "item-details",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleSidebar(customer)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "heavy-font-600" }, [
                                _vm._v(_vm._s(customer.name)),
                              ]),
                              _c("div", [_vm._v(_vm._s(customer.address))]),
                              _c(
                                "div",
                                [
                                  customer.phone
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "md-button md-info md-just-icon md-round",
                                          attrs: {
                                            title: "Customer Phone",
                                            href: "tel:" + customer.phone,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "md-ripple" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-button-content",
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("call"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  customer.email
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "md-button md-warning md-just-icon md-round",
                                          attrs: {
                                            title: "Customer Email",
                                            href: "mailto:" + customer.email,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "md-ripple" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "md-button-content",
                                                },
                                                [
                                                  _c("md-icon", [
                                                    _vm._v("email"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "md-button md-primary md-just-icon md-round",
                                      attrs: { title: "Schedule Stop" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleCreateStop(
                                            customer.customerId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "md-ripple" }, [
                                        _c(
                                          "div",
                                          { staticClass: "md-button-content" },
                                          [_c("md-icon", [_vm._v("event")])],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "md-button md-rose md-just-icon md-round",
                                      attrs: { title: "Add Note" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleAddNotes(customer)
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "md-ripple" }, [
                                        _c(
                                          "div",
                                          { staticClass: "md-button-content" },
                                          [_c("md-icon", [_vm._v("note_add")])],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "md-button md-primary md-just-icon md-round",
                                      attrs: {
                                        to: {
                                          name: "Customer Details",
                                          params: {
                                            customerId: customer.customerId,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "md-ripple" }, [
                                        _c(
                                          "div",
                                          { staticClass: "md-button-content" },
                                          [
                                            _c("md-icon", [
                                              _vm._v("visibility"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "md-layout-item" }, [
                    _c(
                      "span",
                      { staticClass: "text-center no-result-message" },
                      [_vm._v("No available customers to display.")]
                    ),
                  ]),
            ])
          : _c("div", [
              !_vm.isLoading
                ? _c(
                    "div",
                    { staticClass: "list-loader" },
                    [
                      _c("fade-loader", {
                        attrs: { loading: true, color: "#333333" },
                      }),
                      _c("span", [_vm._v("LOADING")]),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
      ]),
      _c(
        "div",
        { staticClass: "drawer-sidebar" },
        [
          _c(
            "md-drawer",
            {
              staticClass: "md-right",
              attrs: { "md-active": _vm.showSidebar },
              on: {
                "update:mdActive": function ($event) {
                  _vm.showSidebar = $event
                },
                "update:md-active": function ($event) {
                  _vm.showSidebar = $event
                },
              },
            },
            [
              _c("md-toolbar", { staticClass: "md-primary" }, [
                _c(
                  "div",
                  { staticClass: "md-toolbar-row" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button",
                        on: {
                          click: function ($event) {
                            _vm.showSidebar = false
                          },
                        },
                      },
                      [_c("md-icon", [_vm._v("close")])],
                      1
                    ),
                    _c("h2", { staticClass: "md-title" }, [
                      _vm._v("Customer Details"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm.sidebarLoader
                ? _c("div", { staticClass: "sidebar-drawer" }, [
                    _c(
                      "div",
                      { staticClass: "sidebar-loader" },
                      [
                        _c("fade-loader", {
                          attrs: { loading: true, color: "#333333" },
                        }),
                        _c("span", [_vm._v("LOADING")]),
                      ],
                      1
                    ),
                  ])
                : _vm.sidebarLoader === false && _vm.selectedCustomer
                ? _c("div", { staticClass: "drawer-container" }, [
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Fullname:"),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.selectedCustomer.firstName) +
                            " " +
                            _vm._s(_vm.selectedCustomer.lastName)
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("Company:")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedCustomer.company)),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("Address:")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.selectedCustomer.address)),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("Phone:")]),
                      _c("div", { staticClass: "value" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "tel:" + _vm.selectedCustomer.phone,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.selectedCustomer.phone
                                    ? _vm.selectedCustomer.phone
                                    : "-"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("Email:")]),
                      _c("div", { staticClass: "value" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "tel:" + _vm.selectedCustomer.email,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.selectedCustomer.email
                                    ? _vm.selectedCustomer.email
                                    : "-"
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("ABN:")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedCustomer.abn
                              ? _vm.selectedCustomer.abn
                              : "-"
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Customer Notes:"),
                      ]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.selectedCustomer.notes
                              ? _vm.selectedCustomer.notes
                              : "-"
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Latest Notes:"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "value" },
                        _vm._l(
                          _vm.selectedCustomer.latestNotes,
                          function (note) {
                            return _c("div", { key: note.noteId }, [
                              _c("div", { staticClass: "note-document" }, [
                                note.documentUrls != null &&
                                note.documentUrls.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        note.documentUrls,
                                        function (documentUrl, documentIndex) {
                                          return _c(
                                            "div",
                                            { key: documentIndex },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: documentUrl.photoUrl,
                                                    download: "",
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm.$_getFileIcon(
                                                    documentUrl.photoName
                                                  )
                                                    ? _c("img", {
                                                        staticClass:
                                                          "file-icon",
                                                        attrs: {
                                                          src:
                                                            "/img/icons/" +
                                                            _vm.$_getFileIcon(
                                                              documentUrl.photoName
                                                            ) +
                                                            ".png",
                                                          alt: "",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        documentUrl.photoName
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]),
                              note.photoUrls != null &&
                              note.photoUrls.length > 0
                                ? _c("div", { staticClass: "note-photos" }, [
                                    _c(
                                      "div",
                                      { staticClass: "note-image-container" },
                                      _vm._l(
                                        note.photoUrls,
                                        function (photoUrl, photoIndex) {
                                          return _c(
                                            "div",
                                            { key: photoIndex },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewPhoto(
                                                        note.photoUrls,
                                                        photoUrl
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "note-image",
                                                    attrs: {
                                                      src: photoUrl.thumbnailUrl,
                                                    },
                                                    on: {
                                                      error: function ($event) {
                                                        return _vm.$_notePhotoLoading(
                                                          $event,
                                                          photoUrl.thumbnailUrl
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _c("span", { staticClass: "note-date-text" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        note.createdDate,
                                        _vm.DATE_TYPES.standardDate
                                      )
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                              _c("div", {
                                staticClass: "note-preview",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$_compiledMarkdown(note.note)
                                  ),
                                },
                              }),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Upcoming Visit:"),
                      ]),
                      _vm.selectedCustomer.upcomingStop
                        ? _c(
                            "div",
                            { staticClass: "value" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      _vm.selectedCustomer.upcomingStop
                                        .tripDate,
                                      _vm.DATE_TYPES.standardDate
                                    )
                                  ) +
                                  ",\n                            "
                              ),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "Stop Details",
                                      params: {
                                        stopId:
                                          _vm.selectedCustomer.upcomingStop
                                            .stopId,
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.selectedCustomer.upcomingStop.status
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "drawer-item" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Last Visit:"),
                      ]),
                      _c(
                        "div",
                        { staticClass: "value" },
                        _vm._l(
                          _vm.selectedCustomer.lastVisitedStops,
                          function (previousStop) {
                            return _c(
                              "div",
                              { key: previousStop.stopId },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        previousStop.tripDate,
                                        _vm.DATE_TYPES.standardDate
                                      )
                                    ) +
                                    ",\n                                "
                                ),
                                _c(
                                  "router-link",
                                  {
                                    attrs: {
                                      to: {
                                        name: "Stop Details",
                                        params: { stopId: previousStop.stopId },
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(previousStop.status) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }